import React, { FunctionComponent } from 'react';
import { Story } from '../../services/models/story';
import { classNames } from '../../utils/class-names';
import { VectorIcon } from '../VectorIcon';

interface Props {
  isPreview?: boolean;
  story: Story;
  briefId: number;
  /** Visibility/hover classes injected by the host card (e.g. group-hover coupling). */
  className?: string;
}

const shareLinkClasses = 'cursor-pointer pr-1.5 text-gray-700 opacity-[0.54] hover:opacity-100';

enum ShareType {
  Email,
  Twitter,
  Facebook,
  LinkedIn,
}

const StoryCardShareOptions: FunctionComponent<Props> = ({
  isPreview,
  story,
  briefId,
  className,
}) => {
  const getShareUrl = (shareType: ShareType) => {
    const mailBody =
      'Check out this story:\r\n\r\n' +
      story.url +
      '\r\n\r\n' +
      'Sent via Newslit - Next-generation news monitoring and research tool. https://newslit.co';

    return shareType === ShareType.Email
      ? `mailto:?subject=${encodeURI(story.title)}&body=${encodeURI(mailBody)}`
      : `https://newslit.co/share?u=${encodeURI(story.url)}&t=${shareType}`;
  };

  const getCommonShareOptions = () => (
    <div className={classNames('flex items-center', className)}>
      <a
        href={getShareUrl(ShareType.Twitter)}
        className={shareLinkClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        <VectorIcon size={20} file="twitter" alt="Tweet" />
      </a>
      <a
        href={getShareUrl(ShareType.LinkedIn)}
        className={shareLinkClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        <VectorIcon size={20} file="linked" alt="LinkedIn Share" />
      </a>
      <a
        className={shareLinkClasses}
        href={getShareUrl(ShareType.Email)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <VectorIcon size={20} file="mail" alt="Email story" />
      </a>
    </div>
  );

  if (isPreview) {
    return <></>;
  }

  return getCommonShareOptions();
};

export default StoryCardShareOptions;
